module.exports = __webpack_public_path__ + "bg.4gBxUvo3.svg";